<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>判读信息</el-breadcrumb-item>
      <el-breadcrumb-item>检查阶段</el-breadcrumb-item>
      <el-breadcrumb-item>查看</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <section class="main-body">
      <ClientBasicInfo
        ref="clientBasicInfoRef"
        :teleNum="teleNum"
        :print="false"
      />
      <br />

      <el-button
        size="mini"
        type="primary"
        @click="preTestDialogVisible = true"
      >
        打印预览
      </el-button>

      <!-- <el-button size="mini" type="primary" > -->
      <!-- 知情同意书下载 -->
      <a
        style="margin-left: 30px; font-size: 14px"
        target="_blank"
        href="https://hyperq.xyz:8443/web/api/ExamService/download/96c81d618bfe4cef8dae95d60f16b6ea/pdf"
        >知情同意书下载</a
      >
      <el-collapse border>
        <el-collapse-item title="病人自述" name="1">
          <SelfStatement
            ref="selfStatementRef"
            :teleNum="teleNum"
            :disabled="false"
          />
        </el-collapse-item>
        <el-collapse-item title="基础问询" name="2">
          <BasicQuery ref="basicQueryRef" :examUuid="examUuid" />
        </el-collapse-item>
        <el-collapse-item title="基础检查" name="3">
          <BasicCheck ref="basicCheckRef" :examUuid="examUuid" />
        </el-collapse-item>
        <el-collapse-item title="EMC检测" name="4">
          <Emc :examUuid="examUuid"  :disabled="disabled" :emcDisabled="false"/>
        </el-collapse-item>
        <el-collapse-item title="心电检测" name="5">
          <Ecg ref="ecgRef" :examUuid="examUuid" />
        </el-collapse-item>
        <el-collapse-item title="HyperQ Stress" name="6">
          <HyperQ ref="hyperQRef" :examUuid="examUuid" />
        </el-collapse-item>
        <el-collapse-item title="HyperQ Rest" name="7">
          <HyperQRest ref="hyperQRestRef" :examUuid="examUuid" />
        </el-collapse-item>
        <el-collapse-item title="检测结果及健康建议" name="8">
          <Prescription ref="prescriptionRef" :examUuid="examUuid" />
        </el-collapse-item>
      </el-collapse>

      <el-row :gutter="30">
        <el-col :span="24" class="alignCenter">
          <el-button
            type="primary"
            size="medium"
            @click="goBack"
            class="fullWidth"
            >返回</el-button
          >
        </el-col>
      </el-row>
    </section>

    <el-dialog
      v-if="preTestDialogVisible"
      title="毕胜普生物科技有限公司"
      :visible.sync="preTestDialogVisible"
      width="100%"
      :before-close="handlePreTestDialogClose"
    >
      <!-- Controls INSIDE dialog -->
      <div
        style="
          display: flex;
          align-items: center;
          gap: 16px;
          flex-wrap: wrap;
          margin-bottom: 12px;
        "
      >
        <el-checkbox-group v-model="selectedPdfTypes">
          <el-checkbox label="basicInfo">基础信息</el-checkbox>

          <el-checkbox label="restingECG">传统静息心电图报告</el-checkbox>

          <el-checkbox label="exerciseECG">
            <span>传统运动心电图报告</span>
            <span style="margin-left: 12px">
              <el-input
                v-model.number="pdfPageRanges.exerciseECG.start"
                size="mini"
                style="width: 90px"
                :disabled="!selectedPdfTypes.includes('exerciseECG')"
                placeholder="开始页"
              />
              <span style="margin: 0 6px">到</span>
              <el-input
                v-model.number="pdfPageRanges.exerciseECG.end"
                size="mini"
                style="width: 90px"
                :disabled="!selectedPdfTypes.includes('exerciseECG')"
                placeholder="结束页(默认到最后)"
              />
            </span>
          </el-checkbox>

          <el-checkbox label="exerciseHyperQ">运动 HyperQ 检测报告</el-checkbox>
          <el-checkbox label="restingHyperQ">静息 HyperQ 检测报告</el-checkbox>
        </el-checkbox-group>

        <el-button
          size="mini"
          type="primary"
          :loading="isMergingPdf"
          @click="generateMergedPdf"
        >
          生成并预览PDF
        </el-button>
      </div>

      <!-- PDF viewer -->
      <iframe
        v-if="mergedPdfBlobUrl"
        :src="mergedPdfBlobUrl"
        style="width: 100%; height: 80vh; border: 0"
      />
      <div
        v-else
        style="
          height: 80vh;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #999;
        "
      >
        请选择PDF并点击“生成并预览PDF”
      </div>
    </el-dialog>
  </div>
</template>

<script>
//引入用户基本信息组件
import ClientBasicInfo from "../../../components/common/ClientBasicInfo";
import SelfStatement from "../../../components/common/selfStatement";
import BasicQuery from "../../../components/common/BasicQuery";
import BasicCheck from "../../../components/common/BasicCheck";
import Emc from "../../../components/common/CCT";
import Ecg from "../../../components/common/Ecg";
import HyperQ from "../../../components/common/HyperQ";
import HyperQRest from "../../../components/common/HyperQRest";
import Prescription from "../../../components/common/Prescription";

export default {
  name: "clientInfo",
  components: {
    ClientBasicInfo,
    SelfStatement,
    BasicQuery,
    BasicCheck,
    Emc,
    Ecg,
    HyperQ,
    HyperQRest,
    Prescription,
  },
  data() {
    return {
      examUuid: "",
      teleNum: "",

      // all checked by default
      selectedPdfTypes: [
        "basicInfo",
        "restingECG",
        "exerciseECG",
        "exerciseHyperQ",
        "restingHyperQ",
      ],

      // page range (only for exerciseECG)
      pdfPageRanges: {
        exerciseECG: { start: 1, end: null }, // end=null => default to last page
      },

      isMergingPdf: false,
      mergedPdfBlobUrl: null,
      preTestDialogVisible: false,
    };
  },
  methods: {
    getPastMedicalHistory(medicalHistory) {
      let history = "";
      if (!medicalHistory) return "";
      if (medicalHistory.diabetes == "是") {
        history += `糖尿病病史${medicalHistory.diabetesYear}年，`;
      }
      if (medicalHistory.highBloodPressure == "是") {
        history += `高血压病史${medicalHistory.highBloodPressureYear}年，`;
      }
      if (medicalHistory.coronaryHeartDisease == "是") {
        history += `冠心病史${medicalHistory.coronaryHeartDiseaseYear}年，`;
      }
      return history;
    },

    getMeditationHistory(medicalHistory) {
      let meds = "";
      if (!medicalHistory) return "";
      if (medicalHistory.medicineHistory == "是") {
        meds += `服用药物：${medicalHistory.medicineName}。`;
      }
      return meds;
    },

    getBasicInfoForPdf() {
      const clientBasicInfo = this.$refs.clientBasicInfoRef; // child component instance (after mounted)
      const basicInfo = clientBasicInfo?.form || {};
      const selfStatement = this.$refs.selfStatementRef; // child component instance (after mounted)
      const medicalHistory = selfStatement?.getMedicalHistory() || "";

      //const basicQuery = this.$refs.basicQueryRef; // child component instance (after mounted)
      //const examBasicQuery = basicQuery?.examBasicQuery || {};

      const basicCheck = this.$refs.basicCheckRef; // child component instance (after mounted)
      const examBasicCheck = basicCheck?.examBasicCheck || {};

      const ecg = this.$refs.ecgRef; // child component instance (after mounted)
      const examEcg = ecg?.examEcg || {};

      const hyperq = this.$refs.hyperQRef; // child component instance (after mounted)
      const examHyperQ = hyperq?.examHyperq || {};

      const hyperqRest = this.$refs.hyperQRestRef; // child component instance (after mounted)
      const examHyperqRest = hyperqRest?.examHyperqRest || {};

      const prescription = this.$refs.prescriptionRef; // child component instance (after mounted)
      const examPrescription = prescription?.prescription || {};

      var info = {
        name: basicInfo.name || "",
        birthDate: basicInfo.birthDate || "45岁",
        gender: basicInfo.gender || "男",
        height: basicInfo.height || "172 cm",
        weight: basicInfo.weight || "70 kg",
        bloodSugar:
          examBasicCheck.bloodSugar.checkTime +
            "数值：" +
            examBasicCheck.bloodSugar.value || "5.6 mmol/L",
        bloodPressure: examBasicCheck.bloodPressure || "120/80 mmHg",
        heartRate: examBasicCheck.heartRate || "72 bpm",
        // NEW: Past Medical History & Medication History
        pastMedicalHistory: this.getPastMedicalHistory(medicalHistory),
        medicationHistory: this.getMeditationHistory(medicalHistory),
        restEcgConclusion: examEcg.restEcgConclusion || "",
        exerciseEcgConclusion: examEcg.exerciseEcgConclusion || "",
        restHyperqDescriptionAndConclusion:
          examHyperqRest.description + "；" + examHyperqRest.conclusion || "",
        exerciseHyperqDescriptionAndConclusion:
          examHyperQ.description + "；" + examHyperQ.conclusion || "",
        advice: examPrescription || "",
      };

      return info;
    },

    splitLines(text, maxLen = 40) {
      if (!text) return [""];
      const s = String(text);
      const out = [];
      for (let i = 0; i < s.length; i += maxLen)
        out.push(s.slice(i, i + maxLen));
      return out;
    },

    async addBasicInfoPage(mergedPdfDoc) {
      const fontkit = (await import("@pdf-lib/fontkit")).default;
      const { rgb } = await import("pdf-lib");
      mergedPdfDoc.registerFontkit(fontkit);

      const fontBytes = await fetch("/fonts/NotoSansSC-Regular.ttf").then(
        (r) => {
          if (!r.ok) throw new Error("Chinese font not found");
          return r.arrayBuffer();
        }
      );
      const font = await mergedPdfDoc.embedFont(fontBytes);

      // A4 size
      const pageWidth = 595;
      const pageHeight = 842;
      const page = mergedPdfDoc.addPage([pageWidth, pageHeight]);

      const marginX = 50;
      const titleSize = 18;
      const labelSize = 13;
      const valueSize = 11;
      const lineHeight = 16;

      // =============== TITLE (centered) ===============
      const title = "信息总览";
      const titleWidth = font.widthOfTextAtSize(title, titleSize);
      let y = pageHeight - 50;
      page.drawText(title, {
        x: (pageWidth - titleWidth) / 2,
        y,
        size: titleSize,
        font,
      });

      // =============== BASIC INFO (2 columns, label on top, value below) ===============
      y -= 50;

      const col1X = marginX;
      const col2X = pageWidth / 2 + 20;

      // Helper: draw label (gray) + value (black) vertically
      const drawLabelValue = (x, yStart, label, value) => {
        page.drawText(label, {
          x,
          y: yStart,
          size: labelSize,
          font,
          color: rgb(0.4, 0.4, 0.4),
        });
        page.drawText(value, {
          x,
          y: yStart - lineHeight,
          size: valueSize,
          font,
        });
        return yStart - lineHeight * 2 - 8; // return next y
      };
      let info = this.getBasicInfoForPdf();
      // Left column
      let leftY = y;
      leftY = drawLabelValue(col1X, leftY, "姓名", info.name || "");
      leftY = drawLabelValue(col1X, leftY, "出生日期", info.birthDate || "");
      leftY = drawLabelValue(col1X, leftY, "性别", info.gender || "");
      leftY = drawLabelValue(col1X, leftY, "身高", info.height + " cm" || "");

      // Right column
      let rightY = y;
      rightY = drawLabelValue(col2X, rightY, "体重", info.weight + " kg" || "");
      rightY = drawLabelValue(col2X, rightY, "血糖", info.bloodSugar || "");
      rightY = drawLabelValue(col2X, rightY, "血压", info.bloodPressure || "");
      rightY = drawLabelValue(
        col2X,
        rightY,
        "心率",
        info.heartRate + " bpm" || ""
      );

      // Move y below both columns
      y = Math.min(leftY, rightY) - 10;

      // =============== BOXED SECTIONS ===============
      const boxWidth = pageWidth - marginX * 2;
      const boxPadding = 10;
      const boxTextSize = 10;
      const boxLineHeight = 14;

      // Helper: wrap text to fit width
      const wrapText = (text, maxWidth, fontSize) => {
        const lines = [];
        const paragraphs = String(text).split("\n");
        for (const para of paragraphs) {
          let line = "";
          for (const ch of para) {
            const testLine = line + ch;
            if (font.widthOfTextAtSize(testLine, fontSize) > maxWidth) {
              if (line) lines.push(line);
              line = ch;
            } else {
              line = testLine;
            }
          }
          if (line) lines.push(line);
        }
        return lines.length ? lines : [""];
      };

      // Helper: draw a section with title + bordered box
      const drawBoxedSection = (yStart, sectionTitle, content) => {
        // Title
        page.drawText(sectionTitle, {
          x: marginX,
          y: yStart,
          size: labelSize,
          font,
        });

        // Wrap content
        const maxTextWidth = boxWidth - boxPadding * 2;
        const lines = wrapText(content, maxTextWidth, boxTextSize);
        const boxHeight = lines.length * boxLineHeight + boxPadding * 2;

        // Box top-left corner
        const boxY = yStart - 5 - boxHeight;

        // Draw border rectangle (no fill, only border)
        page.drawRectangle({
          x: marginX,
          y: boxY,
          width: boxWidth,
          height: boxHeight,
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: undefined, // no fill
        });

        // Draw text inside
        let textY = boxY + boxHeight - boxPadding - boxTextSize;
        for (const ln of lines) {
          page.drawText(ln, {
            x: marginX + boxPadding,
            y: textY,
            size: boxTextSize,
            font,
          });
          textY -= boxLineHeight;
        }

        return boxY - 16; // next section y
      };

      // Draw 7 boxed sections (added 既往病史 and 服药史)
      y = drawBoxedSection(y, "既往病史", info.pastMedicalHistory);
      y = drawBoxedSection(y, "服药史", info.medicationHistory);
      y = drawBoxedSection(y, "静息心电图诊断结论", info.restEcgConclusion);
      y = drawBoxedSection(y, "运动心电图诊断结论", info.exerciseEcgConclusion);
      y = drawBoxedSection(
        y,
        "静息HyperQ结论",
        info.restHyperqDescriptionAndConclusion
      );
      y = drawBoxedSection(
        y,
        "运动HyperQ结论",
        info.exerciseHyperqDescriptionAndConclusion
      );
      y = drawBoxedSection(y, "健康建议", info.advice);
    },

    //后退一步
    goBack() {
      this.$router.push({ path: "/doctor/check" });
    },

    getPdfUrlByType(type) {
      if (type === "basicInfo") return ""; // generated page, no URL

      const ecg = this.$refs.ecgRef; // child component instance (after mounted)
      const examEcg = ecg?.examEcg || {};

      const hyperq = this.$refs.hyperQRef; // child component instance (after mounted)
      const examHyperQ = hyperq?.examHyperq || {};

      const hyperqRest = this.$refs.hyperQRestRef; // child component instance (after mounted)
      const examHyperqRest = hyperqRest?.examHyperqRest || {};

      const urls = {
        // 传统静息心电图报告
        restingECG: examEcg.restPdf || "",

        // 传统运动心电图报告
        exerciseECG: examEcg.postExercisePdf || "",

        // 运动 HyperQ 检测报告
        exerciseHyperQ: examHyperQ.hyperqFile || "",

        // 静息 HyperQ 检测报告
        restingHyperQ: examHyperqRest.restHyperqFile || "",
      };

      return urls[type] || "";
    },

    async fetchPdfBytes(url) {
      const res = await fetch(url, { credentials: "omit" }); // remove if not needed
      if (!res.ok)
        throw new Error(`Failed to fetch PDF: ${url}, status=${res.status}`);
      return await res.arrayBuffer();
    },

    async generateMergedPdf() {
      if (!this.selectedPdfTypes.length) {
        this.$message?.warning?.("请至少选择一个PDF");
        return;
      }

      if (this.mergedPdfBlobUrl) {
        URL.revokeObjectURL(this.mergedPdfBlobUrl);
        this.mergedPdfBlobUrl = null;
      }

      this.isMergingPdf = true;

      try {
        const { PDFDocument } = await import("pdf-lib");
        const merged = await PDFDocument.create();

        for (const type of this.selectedPdfTypes) {
          if (type === "basicInfo") {
            await this.addBasicInfoPage(merged);
            continue;
          }

          const url = this.getPdfUrlByType(type);
          if (!url) continue;

          const bytes = await this.fetchPdfBytes(url);
          const srcDoc = await PDFDocument.load(bytes);

          let pageIndices = srcDoc.getPageIndices();
          const totalPages = srcDoc.getPageCount();

          if (type === "exerciseECG") {
            const startInput = Number(this.pdfPageRanges.exerciseECG.start);
            const endInput = this.pdfPageRanges.exerciseECG.end;

            let startPage =
              Number.isFinite(startInput) && startInput > 0 ? startInput : 1;
            let endPage =
              endInput === null || endInput === undefined || endInput === ""
                ? totalPages
                : Number(endInput);

            if (!Number.isFinite(endPage) || endPage <= 0) endPage = totalPages;

            startPage = Math.max(1, Math.min(startPage, totalPages));
            endPage = Math.max(startPage, Math.min(endPage, totalPages));

            pageIndices = Array.from(
              { length: endPage - startPage + 1 },
              (_, i) => startPage - 1 + i
            );
          }

          const pages = await merged.copyPages(srcDoc, pageIndices);
          pages.forEach((p) => merged.addPage(p));
        }

        const mergedBytes = await merged.save();
        const blob = new Blob([mergedBytes], { type: "application/pdf" });
        this.mergedPdfBlobUrl = URL.createObjectURL(blob);

        this.preTestDialogVisible = true;
      } catch (e) {
        console.error(e);
        this.$message?.error?.("合并PDF失败（请检查URL/CORS/权限）");
      } finally {
        this.isMergingPdf = false;
      }
    },

    handlePreTestDialogClose() {
      this.preTestDialogVisible = false;
      if (this.mergedPdfBlobUrl) {
        URL.revokeObjectURL(this.mergedPdfBlobUrl);
        this.mergedPdfBlobUrl = null;
      }
    },
  },
  created() {
    this.examUuid = this.$route.query.examUuid;
    this.teleNum = this.$route.query.teleNum;
  },

  beforeDestroy() {
    if (this.mergedPdfBlobUrl) URL.revokeObjectURL(this.mergedPdfBlobUrl);
  },
};
</script>
<style scoped lang="less">
header {
  margin-top: 30px;
}

.main-body {
  width: 80%;
  margin: 0 auto;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.checkFeedbackInfo {
  margin-bottom: 10px;
}

.leftpad {
  padding-left: 30px;
}

.alignCenter {
  text-align: center;
}

.fullWidth {
  width: 100%;
}

.print_panel {
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 100px;
}

.signiture {
  margin-left: 65%;
}

@media print {
  body {
    height: auto;
  }
}
</style>